import { useState } from "react"

/**
 * The useToggle hook allows for toggling between true and false values with an initial
 * value specified.
 * @returns An array containing two elements is being returned. The first element is the current value
 * of the toggle, and the second element is a function called `toggle` that can be used to toggle the
 * value.
 */
export function useToggle({initialValue = false}) {
    const [value, setValue] = useState(initialValue)

    if(typeof initialValue !== "boolean") return new Error("The initial value of the useToggle hook must be a boolean!")

    const toggle = (toggleValue) => setValue(prev => {
        if(typeof toggleValue === 'boolean'){
            return toggleValue
        }else{
            return !prev
        }
    })

    return [value, toggle]
}